export const WarningLite = ({ color }) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_19984_18193)">
        <path
          d="M14.352 12.1027L8.77744 2.44731C8.46746 1.91042 7.91226 1.58984 7.29224 1.58984C6.67226 1.58984 6.11703 1.91042 5.80705 2.44731L0.232504 12.1027C-0.0775014 12.6397 -0.0775014 13.2808 0.232504 13.8177C0.54251 14.3546 1.09769 14.6751 1.7177 14.6751H12.8668C13.4868 14.6751 14.042 14.3546 14.352 13.8177C14.662 13.2808 14.662 12.6397 14.352 12.1027ZM13.612 13.3905C13.4565 13.6599 13.1779 13.8207 12.8668 13.8207H1.7177C1.40658 13.8207 1.128 13.6599 0.972467 13.3905C0.816937 13.1211 0.816937 12.7994 0.972467 12.53L6.54707 2.87456C6.7026 2.60515 6.98118 2.44432 7.29227 2.44432C7.60333 2.44432 7.88195 2.60515 8.03748 2.87456L13.6121 12.53C13.7676 12.7994 13.7676 13.1211 13.612 13.3905Z"
          fill={color}
        />
        <path
          d="M7.71968 5.85156H6.86523V10.1238H7.71968V5.85156Z"
          fill={color}
        />
        <path
          d="M7.29218 10.9805C6.97808 10.9805 6.72253 11.236 6.72253 11.5501C6.72253 11.8642 6.97808 12.1198 7.29218 12.1198C7.60626 12.1198 7.86183 11.8642 7.86183 11.5501C7.86183 11.236 7.60629 10.9805 7.29218 10.9805Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19984_18193">
          <rect
            width="14.5845"
            height="14.5845"
            fill="white"
            transform="translate(0 0.839844)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
